(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6967],{

/***/ 61842:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/esg-guide/news",
      function () {
        return __webpack_require__(59814);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 67623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ fetchBoards; }
/* harmony export */ });
/* unused harmony export ViewSetBoard */
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var fetchBoards = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var ref, ref1, ref2, res, resData;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 3:
                    res = _ctx.sent;
                    resData = {
                        code: res === null || res === void 0 ? void 0 : (ref = res.data) === null || ref === void 0 ? void 0 : ref.Code,
                        data: res === null || res === void 0 ? void 0 : (ref1 = res.data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.Data) === null || ref2 === void 0 ? void 0 : ref2.rows
                    };
                    return _ctx.abrupt("return", resData);
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function fetchBoards(body) {
        return _ref.apply(this, arguments);
    };
}();
var ViewSetBoard = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].BOARDS */ .Z.BOARDS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function ViewSetBoard(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 56489:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ breakPoints; }
/* harmony export */ });
var breakPoints = {
    xs_mobile: "(max-width:460px)",
    mobile: "(max-width:767px)",
    tablet: "(min-width:768px) and (max-width:1200px)",
    desktop: "(min-width:1200px)"
};


/***/ }),

/***/ 63820:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19521);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media screen and (max-width: 575px) {\n    display: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: none;\n  .disabled {\n    .page-link {\n      opacity: 0;\n    }\n  }\n  @media screen and (max-width: 575px) {\n    display: flex;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



var PaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-0"
})(_templateObject());
var MobilePaginationWrapper = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-de5ae770-1"
})(_templateObject1());
function NoticePagination(param) {
    var prev = param.prev, currentPage = param.currentPage, getPaginationGroup = param.getPaginationGroup, next = param.next, pages = param.pages, nextEnd = param.nextEnd, prevStart = param.prevStart, handleActive = param.handleActive;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prevStart,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage != 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: prev,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            getPaginationGroup.map(function(item, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    onClick: function() {
                                        return handleActive(item);
                                    },
                                    className: currentPage == item ? "page-item active" : "page-item",
                                    style: {
                                        zIndex: 5
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "page-link",
                                        children: item
                                    })
                                }, index);
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: next,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            }),
                            getPaginationGroup.length > 0 && currentPage < pages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: nextEnd,
                                className: "page-item",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-double-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            }),
            getPaginationGroup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MobilePaginationWrapper, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                    className: "pagination-area",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                        className: "pagination justify-content-start",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage == 1)) {
                                        prev();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage == 1) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-left"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                className: "page-item active",
                                style: {
                                    zIndex: 5
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: currentPage
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                onClick: function() {
                                    if (!(getPaginationGroup.length <= 0 || currentPage >= pages)) {
                                        next();
                                    }
                                },
                                className: "page-item ".concat((getPaginationGroup.length <= 0 || currentPage >= pages) && "disabled"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "page-link",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                        className: "fi-rs-angle-small-right"
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (NoticePagination);


/***/ }),

/***/ 43785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ useBoardListQuery; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51586);
/* harmony import */ var _api_boards__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67623);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87633);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}




var useBoardListQuery = function(param) {
    var boardName = param.boardName, keyword = param.keyword, page = param.page, pageRow = param.pageRow;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useQuery */ .a)({
        queryKey: [
            _common_queryKeys__WEBPACK_IMPORTED_MODULE_1__/* .QUERY_KEYS.ESG.BOARDS.INDEX */ .U.ESG.BOARDS.INDEX(boardName),
            keyword,
            page,
            pageRow
        ],
        queryFn: _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "List",
                            boardName: boardName,
                            keyword: keyword,
                            page: page,
                            page_rows: pageRow
                        };
                        _ctx.next = 3;
                        return (0,_api_boards__WEBPACK_IMPORTED_MODULE_2__/* .fetchBoards */ .P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (!(res.code === "0000")) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            items: res.data.data,
                            totalCount: res.data.total_count,
                            totalPages: res.data.total_page
                        });
                    case 8:
                        return _ctx.abrupt("return", {
                            items: [],
                            totalCount: 0,
                            totalPages: 0
                        });
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    });
};


/***/ }),

/***/ 59814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ news; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/esg-guide/Esg-layout.js
var Esg_layout = __webpack_require__(28680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(19521);
// EXTERNAL MODULE: ./common/styles.js
var styles = __webpack_require__(56489);
;// CONCATENATED MODULE: ./components/esg-guide/news/Esg-guide-news-styles.js
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 991px) {\n    .container {\n      padding: 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: grid;\n  grid-template-columns: repeat(1, 1fr);\n  gap: 20px;\n  margin-bottom: 50px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  cursor: pointer;\n  border: 1px solid #ececec;\n  border-radius: 10px;\n  overflow: hidden;\n  display: flex;\n  & a {\n    color: #1b1b1b;\n    :hover {\n      color: #3bb77e;\n    }\n  }\n  .img_wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    max-width: 150px;\n  }\n\n  .content_wrapper {\n    padding: 10px 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    .post_title {\n      margin-bottom: 10px;\n    }\n    .post_desc {\n      margin-bottom: 10px;\n      word-break: keep-all;\n    }\n    .post_summary {\n      font-size: 12px;\n      line-height: 1.3;\n      color: #b0b0b0;\n    }\n    .post_date {\n      display: flex;\n      align-items: center;\n      & i {\n        margin-right: 5px;\n        margin-top: 2px;\n      }\n    }\n  }\n\n  @media (",
        ") {\n    .img_wrapper {\n      max-width: 200px;\n    }\n  }\n  @media (",
        ") {\n    border: none;\n    border-bottom: 1px solid #ececec;\n    border-radius: 0;\n    padding-bottom: 10px;\n    .post_summary {\n      display: none;\n    }\n  }\n  @media (",
        ") {\n    .img_wrapper {\n      max-width: 130px;\n    }\n    .content_wrapper {\n      padding: 10px;\n    }\n    .post_title {\n      font-size: 16px;\n    }\n    .post_desc {\n      font-size: 14px;\n    }\n    .post_summary {\n      display: none;\n    }\n    .post_date {\n      font-size: 12px;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}


var Container = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-1c3e60fe-0"
})(_templateObject());
var GridList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1c3e60fe-1"
})(_templateObject1());
var ArticleBox = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-1c3e60fe-2"
})(_templateObject2(), styles/* breakPoints.tablet */.E.tablet, styles/* breakPoints.mobile */.E.mobile, styles/* breakPoints.xs_mobile */.E.xs_mobile);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./components/esg-guide/news/Esg-guide-news-list.js





var NewsList = function(param) {
    var show = param.show, newsList = param.newsList;
    var router = (0,next_router.useRouter)();
    var moveToDetail = function(id) {
        router.push("/esg-guide/post/".concat(id));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: newsList === null || newsList === void 0 ? void 0 : newsList.map(function(item, i) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArticleBox, {
                className: "wow fadeIn animated hover-up",
                onClick: function() {
                    return moveToDetail(item.id);
                },
                children: [
                    item.thumbnail && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "img_wrapper",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "".concat(item.thumbnail),
                            alt: "".concat(item.title)
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/esg-guide/post/".concat(item.id),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "content_wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                    className: "post_title",
                                    children: item.title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "post_desc",
                                    children: item.sub_title
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "post_summary",
                                    children: item.summary
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "post_date",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                            className: "fi-rs-clock"
                                        }),
                                        " ",
                                        item.wdate
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }, i);
        })
    });
};
/* harmony default export */ var Esg_guide_news_list = (NewsList);

// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Spinner.js
var Spinner = __webpack_require__(36968);
// EXTERNAL MODULE: ./hook/esg-guide/useBoardListQuery.js
var useBoardListQuery = __webpack_require__(43785);
// EXTERNAL MODULE: ./components/csboard/notice/notice-pagination.js
var notice_pagination = __webpack_require__(63820);
;// CONCATENATED MODULE: ./components/esg-guide/news/Esg-guide-news.js






var EsgGuideNews = function(param) {
    var searchParams = param.searchParams, page = param.page, pageRows = param.pageRows, boardName = param.boardName, onPageChange = param.onPageChange;
    // 데이터 가져오기
    var ref = (0,useBoardListQuery/* useBoardListQuery */.H)({
        boardName: boardName || "news",
        keyword: (searchParams === null || searchParams === void 0 ? void 0 : searchParams.searchTerm) || "",
        page: page || 1,
        pageRow: pageRows || 10
    }), tmp = ref.data, newsData = tmp === void 0 ? {
        items: [],
        totalCount: 0,
        totalPages: 0
    } : tmp, newsLoading = ref.isLoading, error = ref.error;
    // 구조 분해 할당으로 데이터 추출
    var newsList = newsData.items, totalCount = newsData.totalCount, totalPages = newsData.totalPages;
    // 페이지네이션 그룹 계산
    var getPaginationGroup = function() {
        var start = Math.floor(((page || 1) - 1) / 5) * 5;
        return new Array(Math.min(5, totalPages - start)).fill().map(function(_, idx) {
            return start + idx + 1;
        });
    };
    // 사용자 정의 handleActive 함수 - 페이지 변경 처리도 함께 수행
    var customHandleActive = function(pageNumber) {
        var activeClass = (page || 1) === pageNumber ? "active" : "";
        // 페이지 변경 호출
        onPageChange(pageNumber);
        return activeClass;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            newsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "d-flex align-items-center justify-content-center",
                    style: {
                        minHeight: "500px"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner/* default */.Z, {
                        animation: "border",
                        role: "status"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-lg-12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GridList, {
                            children: newsList && newsList.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Esg_guide_news_list, {
                                        newsList: newsList
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "d-flex w-100 justify-content-center mt-30 mb-30",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(notice_pagination/* default */.Z, {
                                                prev: function() {
                                                    return onPageChange((page || 1) - 1);
                                                },
                                                currentPage: page || 1,
                                                getPaginationGroup: getPaginationGroup(),
                                                next: function() {
                                                    return onPageChange((page || 1) + 1);
                                                },
                                                pages: totalPages,
                                                nextEnd: function() {
                                                    return onPageChange(totalPages);
                                                },
                                                prevStart: function() {
                                                    return onPageChange(1);
                                                },
                                                handleActive: customHandleActive
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                className: "d-none d-md-flex align-items-center ml-10",
                                                children: [
                                                    page || 1,
                                                    " / ",
                                                    totalPages
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }) : !newsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-center py-5",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "\uAC80\uC0C9 \uACB0\uACFC\uAC00 \uC5C6\uC2B5\uB2C8\uB2E4."
                                    })
                                })
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var Esg_guide_news = (EsgGuideNews);

// EXTERNAL MODULE: ./components/layout/Layout.js + 38 modules
var Layout = __webpack_require__(32511);
// EXTERNAL MODULE: ./utils/seo/SeoMeta.js
var SeoMeta = __webpack_require__(44027);
;// CONCATENATED MODULE: ./pages/esg-guide/news/index.js





var NewsPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
            parent: "\uD648",
            sub: "ESG\uC790\uB8CC\uC2E4",
            subTitle: "ESG \uD658\uACBD\uB274\uC2A4",
            pageTitle: SeoMeta/* SeoMeta.esgNews.title */.e.esgNews.title,
            pageDesc: SeoMeta/* SeoMeta.esgNews.description */.e.esgNews.description,
            pageKeyword: SeoMeta/* SeoMeta.esgNews.keywords */.e.esgNews.keywords,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Esg_layout/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Esg_guide_news, {})
            })
        })
    });
};
/* harmony default export */ var news = (NewsPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,4027,8680,9774,2888,179], function() { return __webpack_exec__(61842); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);